import React from "react";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  formatCents,
  formatLedgerTimestamp,
  ledgerTypeLabel,
} from "./zipSlotAdsHelpers";

const TransactionList = ({
  rows,
  loadingMore = false,
  hasMore = false,
  onLoadMore,
}) => {
  if (!rows?.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No balance transactions yet.
      </Typography>
    );
  }

  return (
    <>
      <TableContainer component={Paper} sx={{ mb: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>When</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Balance after</TableCell>
              <TableCell>ZIP</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{formatLedgerTimestamp(row.createdAt)}</TableCell>
                <TableCell>{ledgerTypeLabel(row.type)}</TableCell>
                <TableCell>{formatCents(row.amountCents)}</TableCell>
                <TableCell>{formatCents(row.balanceAfterCents)}</TableCell>
                <TableCell>{row.relatedZip || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {hasMore ? (
        <Box>
          <LoadingButton loading={loadingMore} onClick={onLoadMore}>
            Load more
          </LoadingButton>
        </Box>
      ) : null}
    </>
  );
};

export default TransactionList;
